export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.a89597f9.svg";